import { useNavigate } from "react-router";
import PageContainer from "~/components/common/PageContainer";
import { Button } from "~/components/ui/button";

export default function NoDealOrProduct() {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <div className="container mx-auto py-12">
        <div className="text-center">
          <p className="mb-8 text-gray-600">This product is no longer available.</p>
          <Button variant="primary" onClick={() => navigate("/shop")}>
            Back to Shop
          </Button>
        </div>
      </div>
    </PageContainer>
  );
}
